module.exports = "/images/icon-edit.svg?b3394b2ce38fd2afe6873e890d488a17";